export default "__VITE_ASSET__7d6ed2f7__"